import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Observable, throwError, map, switchMap, catchError } from "rxjs";
import { Action, Store } from "@ngrx/store";
import { Injectable } from "@angular/core";
import * as ActionConfigurationManager from '../_actions/config.actions';
import { getDiscountFailed, getDiscountSuccess } from "../_actions/discount.actions";
import { OrderService } from "../_services/order.service";
import { TaxSubmissionService } from "../_services/tax-submission.service";
import { Vehicle } from "../_models/vehicle";
import { Cart } from "../_models/cart";
import { updateCartSuccess } from "../_actions/cart.actions";
import { RatesResponse } from "../_models/rates";
import { getSurchargeAmountFromRates } from "../_utils/surcharge-lookup.util";

@Injectable()
export class DiscountEffects {
    public abandonedCartTrigger: Observable<Action> = createEffect(() =>
        this.actions$
            .pipe(
                ofType(ActionConfigurationManager.GET_DISCOUNT),
                switchMap((action) => this.orderService.getDiscount(action)
                    .pipe(
                        map((response: any) => {
                            const _cart: Cart = JSON.parse(sessionStorage.getItem("cart"));
                            const registration = JSON.parse(sessionStorage.getItem("registration"));
                            const _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));

                            let surchargeAmount = 0;

                            if (_cart.commercialUse) {
                                surchargeAmount += this.getSurchargeOption(
                                  'Professional Services'
                                );
                                surchargeAmount += this.getSurchargeOption(
                                  'Commercial'
                                );
                                surchargeAmount += this.getSurchargeOption(
                                  'LIGHT DUTY COMMERCIAL'
                                );
                            }

                            if (_cart.liftKit) {
                                surchargeAmount += this.getSurchargeOption('Lift Kit');
                            }

                            if (_cart.valet) {
                                surchargeAmount += this.getSurchargeOption(
                                  'VALET SERVICE'
                                );
                            }

                            _cart.subtotal = response.data.totalDiscountedAmount + surchargeAmount;
                            _cart.savings = response.data.totalSavings;
                            _cart.discountName = response.data.name;
                            this.store.dispatch(updateCartSuccess(_cart));

                            this.taxSubmissionService.submitTaxRequest({
                              cart: _cart,
                              vehicle: _vehicle,
                              registration: registration
                            });

                            return getDiscountSuccess(response);
                        }),
                        catchError((error) => {
                            this.store.dispatch(getDiscountFailed())
                            return throwError(error)
                        })
                    )
                )
            )
    )

    getSurchargeOption(option: string): number {
        const _rates: RatesResponse = JSON.parse(
          sessionStorage.getItem("rates")
        );
        return getSurchargeAmountFromRates(_rates, option);
      }

    constructor(
        private actions$: Actions,
        private orderService: OrderService,
        public store: Store<{}>,
        private taxSubmissionService: TaxSubmissionService
    ) { }
}
